import { useState } from 'react';

export const useDocumentsModal = ({ isDocumentsLoaded, documentsList, onLoadDocuments }) => {
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [documentsToOpen, setDocumentsToOpen] = useState([]);
    const [documentToOpen, setDocumentToOpen] = useState({});


    const handleCloseDocumentsModal = (scrollPercentage) => {
        setShowDocumentModal(false);
    };
    const handleOpenDocumentsModal = (documentsList, documentToOpen) => {
        const pendingDocuments = documentsList.filter(
            document => !document.isAccepted && document.dmsDocumentType !== documentToOpen?.dmsDocumentType
        );
        const documentToOpenWithFile = documentsList.find(
            document => document.dmsDocumentType === documentToOpen?.dmsDocumentType
        );
        setDocumentsToOpen(documentToOpenWithFile ? [documentToOpenWithFile, ...pendingDocuments] : pendingDocuments);
        setShowDocumentModal(true);

    };
    const handleShowDocumentsModal = documentToOpen => {
        if (isDocumentsLoaded) {
            handleOpenDocumentsModal(documentsList, documentToOpen);
        } else {
            setDocumentToOpen(documentToOpen)
            onLoadDocuments();
        }
    };

    return {
        showDocumentModal,
        documentsToOpen,
        documentToOpen,
        handleOpenDocumentsModal,
        setDocumentsToOpen,
        handleShowDocumentsModal,
        handleCloseDocumentsModal,
    };
};
